@if (bannerNode | async; as item) {
  <div class="main_inner-wrapper">
    <div class="yCmsContentSlot row dashboard-support" [ngClass]="currentSite === 'seqirusb2b-uk'?'dashboard_Section_SupportUk':''">
      <div class="col-sm-12 col-md-12" [ngClass]="currentSite === 'seqirusb2b-uk'?'dashboard_ContainerUk':''">
        @if (currentSite === 'seqirusb2b-flu360') {
          <div class="col-sm-12 col-lg-6 dashboard-supportsection float_left control">
            <div class="dashboard-support-container">
              @if (vssdata) {
                <div class="dashboard-support-text">{{'dashboard.support_text' | cxTranslate}}</div>
                <div class="dashboard-support-title">{{'dashboard.support_subtext' | cxTranslate}}</div>
                <div class="dashboard-support-emailtext">{{'dashboard.emaillabel' | cxTranslate}}
                  &nbsp;<a href="mailto:{{vssdata.emailId}}"
                class="dashboard-support-emaillink">{{vssdata.emailId}}</a>
              </div>
              <div class="dashboard-support-emailtext">{{'dashboard.calllabel' | cxTranslate}}
                &nbsp;<a href="tel:{{vssdata.formatPhoneNumber}}" class="dashboard-support-emaillink">{{vssdata.contact}}</a>
              </div>
            }
          </div>
        </div>
      }
      <div class="col-sm-12 col-lg-6 float_left" [ngClass]="currentSite === 'seqirusb2b-uk'?'dashboard_bottomlinkuk':''">
        @if (currentSite == 'seqirusb2b-uk') {
          <div [style.backgroundImage]="item?.productMediaPdf ? 'url(' + getImage(item.productMediaPdf) + ')' : null" class="bg_Img bg_Img_container"></div>
        }
        <div [ngClass]="currentSite === 'seqirusb2b-uk'?'dashboard-support-containeruk':'dashboard-support-container'">
          <div class="dashboard-support-text">{{item.title}}</div>
          @if (currentSite === 'seqirusb2b-uk') {
            <div class="dashboard-supporttexthidden">{{item.text1}}</div>
          }
          <div [ngClass]="currentSite === 'seqirusb2b-uk'?'dashboard-support-emailtextuk':'dashboard-support-emailtext'" [innerHTML]="item.text2"></div>
          <div [ngClass]="currentSite === 'seqirusb2b-uk'?'dashboard-support-emailtextuk':'dashboard-support-emailtext'" [innerHTML]="item.content"></div>
        </div>
      </div>
    </div>
  </div>
</div>
}